import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { ActorType } from "@common/types/auditLog";
import { useCurrentWorkspaceMembers } from "@api/workspaceMember.api";
import { KICK_ACTOR_LABEL, KICK_SUPPORT_LABEL } from "@common/constants/actor";
import { DOCUMENT_SOURCE_INTEGRATIONS } from "@components/history/components/integrationActors";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const UploaderFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: members = [] } = useCurrentWorkspaceMembers();
    const { uploaderIds, uploaderType, uploaderSources } = filters;

    const labels = useMemo(() => {
        const result: string[] = [];

        if (uploaderIds?.includes(null)) {
            result.push(KICK_ACTOR_LABEL);
        }
        if (uploaderType === ActorType.SUPPORT) {
            result.push(KICK_SUPPORT_LABEL);
        }

        for (const integration of DOCUMENT_SOURCE_INTEGRATIONS) {
            if (uploaderSources?.includes(integration.documentSource)) {
                result.push(integration.label);
            }
        }

        const userIds = uploaderIds?.filter((id): id is number => id !== null);
        if (userIds && userIds.length > 0) {
            const selected = members.filter((m) => userIds.includes(m.user.id));
            result.push(...selected.map((m) => m.user.name));
        }

        return result;
    }, [uploaderIds, uploaderType, uploaderSources, members]);

    return formatFilterLabel(labels);
};
